import { Toaster } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import NotFound from "@/pages/NotFound";
import { Route, Switch } from "wouter";
import ErrorBoundary from "./components/ErrorBoundary";
import { ThemeProvider } from "./contexts/ThemeContext";
import Home from "./pages/Home";
import Dashboard from "./pages/Dashboard";
import Connect from "./pages/Connect";
import Persons from "./pages/Persons";
import Events from "./pages/Events";
import EventDetail from "./pages/EventDetail";
import Agents from "./pages/Agents";
import RoutingRules from "./pages/RoutingRules";
import AgentEvent from "./pages/AgentEvent";
import Reports from "./pages/Reports";
import MobileApp from "./pages/MobileApp";
import NamedQrCodes from "./pages/NamedQrCodes";

function Router() {
  return (
    <Switch>
      <Route path="/" component={Home} />
      <Route path="/dashboard" component={Dashboard} />
      <Route path="/dashboard/:sessionId" component={Dashboard} />
      <Route path="/connect/:sessionCode" component={MobileApp} />
      <Route path="/persons" component={Persons} />
      <Route path="/events" component={Events} />
      <Route path="/events/:eventId" component={EventDetail} />
      <Route path="/agents" component={Agents} />
      <Route path="/routing" component={RoutingRules} />
      <Route path="/agent-event/:eventId" component={AgentEvent} />
      <Route path="/reports" component={Reports} />
      <Route path="/app" component={MobileApp} />
      <Route path="/qr-codes" component={NamedQrCodes} />
      <Route path="/404" component={NotFound} />
      <Route component={NotFound} />
    </Switch>
  );
}

function App() {
  return (
    <ErrorBoundary>
      <ThemeProvider defaultTheme="dark">
        <TooltipProvider>
          <Toaster richColors position="top-right" />
          <Router />
        </TooltipProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
}

export default App;
